import classNames from 'classnames';
import React from 'react';
import IconClose from '../IconClose/IconClose';

import css from './Chip.module.css';

const Chip = props => {
  const { option, val, removeOption, onBlur } = props;
  return (
    <div
      className={classNames(css.chip, {
        [css.noIconChip]: !option?.icon,
      })}
      key={val}
    >
      {option?.icon && <span className={css.chipIcon}>{option.icon}</span>}

      <span className={css.chipContent}>{option?.label}</span>
      <button
        type="button"
        className={css.closeBtn}
        onClick={() => {
          removeOption(val);
          onBlur?.();
        }}
      >
        <IconClose className={css.closeIcon} />
      </button>
    </div>
  );
};

export default Chip;
